<h5>{{ 'STEP2.question' | translate  }}</h5>
<app-numeric-up-down [(value)]="quotation.waiters"></app-numeric-up-down>
<i class="question" [innerHTML]="'STEP2.description' | translate"></i>
